import { Option } from "common/blocks/Dropdown";

export const HPMileageOptions = [
    {
        label: "N/A",
        value: undefined,
    },
] as Option[];

export const buildOptions = (options: string[], labelPostfix: string): Option[] =>
    options.map(
        (value) =>
            ({
                label: `${value} ${labelPostfix}`,
                value,
            }) as Option
    );
